import axios from "axios";

const ep_set_permit_bsims = `${process.env.VUE_APP_PB_API}/ags/permit/set_permit`;
const ep_list_set_permit = `${process.env.VUE_APP_PB_API}/ags/permit/list-set-permit`;
const ep_retry_set_permit = `${process.env.VUE_APP_PB_API}/ags/permit/api_set_permit`;
const ep_list_gate_permit = `${process.env.VUE_APP_PB_API}/ags/odol/history`;
const ep_gate_odol_info = `${process.env.VUE_APP_PB_API}/ags/odol/info`;

const updateVehicle = (data) => {
  console.log("inside updateVehicle", data);
  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: `${process.env.VUE_APP_PB_API}/ags/vehicle/update`,
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(data),
  };
  return axios
    .request(config)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};

const approveMware = (data) => {
  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: `${process.env.VUE_APP_PB_API}/ags/events/approve`,
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(data),
  };
  return axios
    .request(config)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};

const createManualPermit = (data) => {
  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: `${process.env.VUE_APP_PB_API}/ags/gate_permit/create-manual-permit`,
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(data),
  };
  return axios
    .request(config)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};

const verifiedManualQRCode = (data) => {
  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: `${process.env.VUE_APP_PB_API}/ags/gate_permit/verified-manual-qr-code`,
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(data),
  };
  return axios
    .request(config)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};

const addPermitLooseCargo = (data) => {
  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: `${process.env.VUE_APP_PB_API}/ags/odol/add-permit-loose-cargo`,
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(data),
  };
  return axios
    .request(config)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};

const bsimsLooseCargolValidate = (data) => {
  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: `${process.env.VUE_APP_PB_API}/ags/odol/bsims-loosecargo-validate`,
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(data),
  };
  return axios
    .request(config)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};

const showReasonVehicle = (data) => {
  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: `${process.env.VUE_APP_PB_API}/ags/vehicle/show-reason`,
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(data),
  };
  console.log("showReasonVehicleX", data);
  return axios
    .request(config)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};

const disableReasonVehicle = (data) => {
  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: `${process.env.VUE_APP_PB_API}/ags/vehicle/disable-reason`,
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(data),
  };
  console.log("disableReasonVehicleX", data);
  return axios
    .request(config)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};

const getInOutGateOdolInfo = () => {
  let config = {
    method: "get",
    maxBodyLength: Infinity,
    url: ep_gate_odol_info,
    headers: {
      "Content-Type": "application/json",
    },
  };
  return axios
    .request(config)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};

const auditLog = (page = 1) => {
  let config = {
    method: "get",
    maxBodyLength: Infinity,
    url: `${process.env.VUE_APP_PB_API}/ags/odol/audit-log?page=${page}`,
    headers: {
      "Content-Type": "application/json",
    },
  };

  return axios
    .request(config)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};

const listGateOdol = (data) => {
  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: ep_list_gate_permit,
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(data),
  };
  return axios
    .request(config)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};

const setPermitBsims = (data) => {
  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: ep_set_permit_bsims,
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(data),
  };

  return axios
    .request(config)
    .then((response) => JSON.stringify(response.data))
    .catch((error) => JSON.stringify(error));
};

const listSetPermit = (data) => {
  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: `${ep_list_set_permit}?page=${data.current_page}`,
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(data),
  };

  return axios
    .request(config)
    .then((response) => JSON.stringify(response.data))
    .catch((error) => JSON.stringify(error));
};

const retrySetPermit = (data) => {
  let payload = {
    cont_no: data.cont_no,
    id_trans: data.bsims_id,
    in_out: data.kd_transaksi,
    no_pol: data.lic_plate,
    id_gatepass: data.qr_code,
  };

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: `${ep_retry_set_permit}`,
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(payload),
  };

  return axios
    .request(config)
    .then((response) => JSON.stringify(response.data))
    .catch((error) => JSON.stringify(error));
};

const doubleInQrCode = (data) => {
  console.log("doubleInQrCode", data);
  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: `${process.env.VUE_APP_PB_API}/ags/gate_permit/double-in-qrcode`,
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(data),
  };

  return axios
    .request(config)
    .then((response) => JSON.stringify(response.data))
    .catch((error) => JSON.stringify(error));
};

const bypassPermit = (data) => {
  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: `${process.env.VUE_APP_PB_API}/ags/gate_permit/bypass_permit`,
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(data),
  };

  return axios
    .request(config)
    .then((response) => JSON.stringify(response.data))
    .catch((error) => JSON.stringify(error));
};

export {
  updateVehicle,
  approveMware,
  createManualPermit,
  verifiedManualQRCode,
  addPermitLooseCargo,
  bsimsLooseCargolValidate,
  doubleInQrCode,
  setPermitBsims,
  listSetPermit,
  retrySetPermit,
  bypassPermit,
  listGateOdol,
  getInOutGateOdolInfo,
  auditLog,
  disableReasonVehicle,
  showReasonVehicle,
};
